// extracted by mini-css-extract-plugin
module.exports = {"dl-wrapper":"SoldBy_dl-wrapper__6NNuX","icon-wrapper":"SoldBy_icon-wrapper__5ymFt","dt":"SoldBy_dt__lp6Cz","dd":"SoldBy_dd__Sr4cu","license_plate":"SoldBy_license_plate__kac6E"};